export const LANGS = ["fi", "sv", "en"];

export const translations = {
  fi: {
    nav: { services: "Palvelut", about: "Meistä", why: "Miksi me", contact: "Yhteystiedot", cta: "Ota yhteyttä" },
    hero: {
      label: "Tilitoimisto · Vaasa · Suomi",
      lines: ["Kirjanpito.", "Verotus.", "Palkanlaskenta."],
      sub: "Hoidamme yrityksesi koko taloushallinnon — tarkasti ja ajallaan. Palvelemme yrityksiä kaikissa kokoluokissa, suomeksi, ruotsiksi ja englanniksi.",
      ctaPrimary: "Pyydä tarjous",
      ctaSecondary: "Tutustu palveluihin",
      badge: "Aina",
      badgeText: "lähellä ja tavoitettavissa",
      scroll: "Selaa alas",
    },
    marquee: ["Kirjanpito", "Verotus", "Palkanlaskenta", "Tilinpäätös", "Neuvonta", "Vaasa · Suomi", "Y-tunnus 3631579-2"],
    about: {
      label: "Meistä",
      title: "Täällä sinun yritystäsi varten.",
      p1: "DKT Business Account Ab Oy on vaasalainen tilitoimisto, joka hoitaa kirjanpidon, verotuksen ja palkanlaskennan. Hoidamme taloushallintosi kokonaisuudessaan — sinä voit keskittyä liiketoimintaasi.",
      p2: "Uskomme, että jokainen yritys ansaitsee henkilökohtaista palvelua. Jokainen luku tarkistetaan, jokainen määräaika pidetään — ja me olemme aina tavoitettavissa.",
      stats: [
        { v: "Aina", l: "Tavoitettavissa" },
        { v: "3", l: "Palvelukieltä" },
        { v: "100%", l: "Henkilökohtaista palvelua" },
      ],
    },
    services: {
      label: "Palvelut",
      title: "Mitä teemme",
      chapters: [
        { n: "01", title: "Kirjanpito", desc: "Kirjanpito ja tilinpäätös — kirjasi ovat aina ajan tasalla.", items: ["Kirjanpito", "Tilinpäätös ja vuosikertomus", "Myynti- ja ostoreskontra", "ALV-ilmoitukset"] },
        { n: "02", title: "Verotus", desc: "Verosuunnittelua ja -ilmoituksia ilman yllätyksiä.", items: ["Verosuunnittelu", "Veroilmoitukset", "Ennakkoverot ja muutoshakemukset", "Veroneuvonta"] },
        { n: "03", title: "Palkanlaskenta", desc: "Palkat, ilmoitukset ja työnantajan velvollisuudet ajallaan.", items: ["Palkanlaskenta", "Tulorekisteri-ilmoitukset", "Työnantajan ilmoitukset", "Lomat ja lomakorvaukset"] },
        { n: "04", title: "Neuvonta", desc: "Tukea yrityksesi jokaiseen vaiheeseen — perustamisesta kasvuun.", items: ["Yrityksen perustaminen", "Budjetointi ja ennusteet", "Talousraportointi", "Liiketoiminnan neuvonta"] },
      ],
    },
    why: {
      label: "Miksi me",
      title: "Kumppani kaikenkokoisille yrityksille.",
      pillars: [
        { title: "Helppo aloittaa", desc: "Tule sellaisena kuin olet — hoidamme loput. Palvelemme niin uusia kuin vakiintuneita yrityksiä." },
        { title: "Kolmikielinen tilitoimisto", desc: "Olemme kolmikielinen tilitoimisto — palvelemme suomeksi, ruotsiksi ja englanniksi." },
        { title: "Paikallinen", desc: "Vaasalainen toimisto Olympiakadulla. Lähellä ja tavoitettavissa." },
        { title: "Henkilökohtainen", desc: "Saat aina oman yhteyshenkilön, joka tuntee yrityksesi." },
      ],
    },
    team: {
      label: "Tiimi",
      title: "Tutustu tiimiimme.",
      people: [
        {
          key: "toini",
          name: "Toini Malmi",
          role: "Pääyhteyshenkilö",
          desc: "Toini hoitaa kaiken — kirjanpidosta verotukseen ja palkkoihin. Häneen voit aina olla yhteydessä.",
          phone: "+358 40 749 0507",
          email: "toini.malmi@dktaccounting.fi",
        },
        {
          key: "mikael",
          name: "Mikael Knif",
          role: "ALV-ilmoitukset & Fennoa",
          desc: "Mikael vastaa arvonlisäveroilmoituksista ja Fennoa-verkkotaloushallinnosta.",
          phone: "+358 50 374 9614",
          email: "mikael.knif@dktaccounting.fi",
        },
        {
          key: "helena",
          name: "Helena Korkeamäki",
          role: "ALV- ja veroilmoitukset",
          desc: "Helena vastaa arvonlisävero- ja veroilmoituksista sekä muista veroasioista.",
          email: "helena.korkeamaki@dktaccounting.fi",
        },
        {
          key: "dameh",
          name: "Da Meh Beh",
          role: "ALV- ja veroilmoitukset",
          desc: "Da Meh hoitaa arvonlisävero- ja veroilmoitukset.",
          email: "dameh.beh@dktaccounting.fi",
        },
      ],
      fennoaTitle: "Fennoa-verkkotaloushallinto",
      fennoaDesc: "Olemme Fennoa-kumppani. Fennoassa kuitit ja asiakirjat käsitellään täysin sähköisesti — kaikki tallentuu turvallisesti verkkoon, mikä helpottaa arkeasi. Kiinnostuitko? Ota yhteyttä Mikaeliin.",
      fennoaCta: "Kysy Mikaelilta",
    },
    contact: {
      label: "Yhteystiedot",
      title: "Kerro, miten voimme auttaa.",
      sub: "Jätä viesti — palaamme asiaan mahdollisimman pian.",
      name: "Nimi",
      email: "Sähköposti",
      phone: "Puhelin (valinnainen)",
      company: "Yritys (valinnainen)",
      message: "Viesti",
      submit: "Lähetä viesti",
      sending: "Lähetetään…",
      success: "Kiitos viestistäsi! Palaamme asiaan pian.",
      error: "Lähetys epäonnistui. Yritä uudelleen.",
      note: "Voit ottaa yhteyttä myös suoraan puhelimitse tai sähköpostitse.",
      addressLabel: "Käyntiosoite",
      idLabel: "Y-tunnus",
    },
    footer: {
      rights: "Kaikki oikeudet pidätetään.",
      backToTop: "Takaisin ylös",
      servicesTitle: "Palvelut",
      companyTitle: "Yritys",
    },
  },
  sv: {
    nav: { services: "Tjänster", about: "Om oss", why: "Varför vi", contact: "Kontakt", cta: "Kontakta oss" },
    hero: {
      label: "Redovisningsbyrå · Vasa · Finland",
      lines: ["Bokföring.", "Skatter.", "Löner."],
      sub: "Vi sköter hela ditt företags ekonomiförvaltning — noggrant och i tid. Vi betjänar företag i alla storlekar, på finska, svenska och engelska.",
      ctaPrimary: "Be om offert",
      ctaSecondary: "Se våra tjänster",
      badge: "Alltid",
      badgeText: "nära och tillgängliga",
      scroll: "Bläddra ner",
    },
    marquee: ["Bokföring", "Skatter", "Lönehantering", "Bokslut", "Rådgivning", "Vasa · Finland", "FO-nummer 3631579-2"],
    about: {
      label: "Om oss",
      title: "Här för ditt företag.",
      p1: "DKT Business Account Ab Oy är en redovisningsbyrå i Vasa som sköter bokföring, skatter och lönehantering. Vi sköter hela din ekonomiförvaltning — så att du kan fokusera på din verksamhet.",
      p2: "Vi tror att varje företag förtjänar personlig service. Varje siffra kontrolleras, varje deadline hålls — och vi finns alltid inom räckhåll.",
      stats: [
        { v: "Alltid", l: "Tillgängliga" },
        { v: "3", l: "Servicespråk" },
        { v: "100%", l: "Personlig service" },
      ],
    },
    services: {
      label: "Tjänster",
      title: "Vad vi gör",
      chapters: [
        { n: "01", title: "Bokföring", desc: "Bokföring och bokslut — dina böcker är alltid uppdaterade.", items: ["Bokföring", "Bokslut och årsredovisning", "Kund- och leverantörsreskontra", "Momsdeklarationer"] },
        { n: "02", title: "Skatter", desc: "Skatteplanering och deklarationer utan överraskningar.", items: ["Skatteplanering", "Skattedeklarationer", "Förskottsskatter och ändringsansökningar", "Skatterådgivning"] },
        { n: "03", title: "Löner", desc: "Löner, anmälningar och arbetsgivarskyldigheter i tid.", items: ["Löneberäkning", "Anmälningar till inkomstregistret", "Arbetsgivaranmälningar", "Semester och semesterersättning"] },
        { n: "04", title: "Rådgivning", desc: "Stöd i varje skede av ditt företag — från grundande till tillväxt.", items: ["Företagsgrundande", "Budgetering och prognoser", "Ekonomirapportering", "Affärsrådgivning"] },
      ],
    },
    why: {
      label: "Varför vi",
      title: "En partner för företag i alla storlekar.",
      pillars: [
        { title: "Lätt att börja", desc: "Kom som du är — vi sköter resten. Vi hjälper både nya och etablerade företag." },
        { title: "Trespråkig byrå", desc: "Vi är en trespråkig redovisningsbyrå — vi betjänar på finska, svenska och engelska." },
        { title: "Lokal", desc: "En byrå i Vasa på Olympiagatan. Nära och alltid tillgänglig." },
        { title: "Personlig", desc: "Du får alltid en egen kontaktperson som känner ditt företag." },
      ],
    },
    team: {
      label: "Teamet",
      title: "Möt vårt team.",
      people: [
        {
          key: "toini",
          name: "Toini Malmi",
          role: "Huvudkontaktperson",
          desc: "Toini sköter allt — från bokföring till skatter och löner. Hör gärna av dig till henne.",
          phone: "+358 40 749 0507",
          email: "toini.malmi@dktaccounting.fi",
        },
        {
          key: "mikael",
          name: "Mikael Knif",
          role: "Momsdeklarationer & Fennoa",
          desc: "Mikael ansvarar för momsdeklarationerna och för Fennoa-ekonomihanteringen online.",
          phone: "+358 50 374 9614",
          email: "mikael.knif@dktaccounting.fi",
        },
        {
          key: "helena",
          name: "Helena Korkeamäki",
          role: "Moms- och skattedeklarationer",
          desc: "Helena ansvarar för moms- och skattedeklarationer samt övriga skatteärenden.",
          email: "helena.korkeamaki@dktaccounting.fi",
        },
        {
          key: "dameh",
          name: "Da Meh Beh",
          role: "Moms- och skattedeklarationer",
          desc: "Da Meh sköter moms- och skattedeklarationer.",
          email: "dameh.beh@dktaccounting.fi",
        },
      ],
      fennoaTitle: "Fennoa-ekonomihantering online",
      fennoaDesc: "Vi är Fennoa-partner. I Fennoa hanteras kvitton och handlingar helt elektroniskt — allt lagras säkert online, vilket underlättar din vardag. Intresserad? Kontakta Mikael.",
      fennoaCta: "Fråga Mikael",
    },
    contact: {
      label: "Kontakt",
      title: "Berätta hur vi kan hjälpa dig.",
      sub: "Lämna ett meddelande — vi återkommer så snart som möjligt.",
      name: "Namn",
      email: "E-post",
      phone: "Telefon (valfritt)",
      company: "Företag (valfritt)",
      message: "Meddelande",
      submit: "Skicka meddelande",
      sending: "Skickar…",
      success: "Tack för ditt meddelande! Vi återkommer snart.",
      error: "Sändningen misslyckades. Försök igen.",
      note: "Du kan också nå oss direkt per telefon eller e-post.",
      addressLabel: "Besöksadress",
      idLabel: "FO-nummer",
    },
    footer: {
      rights: "Alla rättigheter förbehållna.",
      backToTop: "Till toppen",
      servicesTitle: "Tjänster",
      companyTitle: "Företag",
    },
  },
  en: {
    nav: { services: "Services", about: "About", why: "Why us", contact: "Contact", cta: "Get in touch" },
    hero: {
      label: "Accounting firm · Vaasa · Finland",
      lines: ["Bookkeeping.", "Tax.", "Payroll."],
      sub: "We take care of your company's entire financial administration — precisely and on time. We serve businesses of all sizes, in Finnish, Swedish and English.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "Explore services",
      badge: "Always",
      badgeText: "close by & reachable",
      scroll: "Scroll down",
    },
    marquee: ["Bookkeeping", "Tax", "Payroll", "Financial statements", "Advisory", "Vaasa · Finland", "Business ID 3631579-2"],
    about: {
      label: "About",
      title: "Here for your business.",
      p1: "DKT Business Account Ab Oy is an accounting firm in Vaasa handling bookkeeping, tax and payroll. We manage your financial administration end to end — so you can focus on your business.",
      p2: "We believe every business deserves personal service. Every figure is checked, every deadline is kept — and we're always within reach.",
      stats: [
        { v: "Always", l: "Reachable" },
        { v: "3", l: "Service languages" },
        { v: "100%", l: "Personal service" },
      ],
    },
    services: {
      label: "Services",
      title: "What we do",
      chapters: [
        { n: "01", title: "Bookkeeping", desc: "Bookkeeping and financial statements — your books always up to date.", items: ["Bookkeeping", "Financial statements & annual report", "Sales & purchase ledgers", "VAT filings"] },
        { n: "02", title: "Tax", desc: "Tax planning and filings without surprises.", items: ["Tax planning", "Tax returns", "Prepayments & adjustment claims", "Tax advisory"] },
        { n: "03", title: "Payroll", desc: "Salaries, reports and employer obligations — always on time.", items: ["Payroll processing", "Incomes Register reports", "Employer filings", "Holidays & holiday pay"] },
        { n: "04", title: "Advisory", desc: "Support at every stage of your business — from founding to growth.", items: ["Company formation", "Budgeting & forecasts", "Financial reporting", "Business advisory"] },
      ],
    },
    why: {
      label: "Why us",
      title: "A partner for businesses of all sizes.",
      pillars: [
        { title: "Easy to start", desc: "Come as you are — we handle the rest. We help both new and established businesses." },
        { title: "Trilingual firm", desc: "We are a trilingual accounting firm — serving you in Finnish, Swedish and English." },
        { title: "Local", desc: "A Vaasa-based firm on Olympiakatu. Close by and always reachable." },
        { title: "Personal", desc: "You always get a dedicated contact person who knows your business." },
      ],
    },
    team: {
      label: "Team",
      title: "Meet our team.",
      people: [
        {
          key: "toini",
          name: "Toini Malmi",
          role: "Main contact",
          desc: "Toini takes care of everything — from bookkeeping to tax and payroll. Feel free to contact her anytime.",
          phone: "+358 40 749 0507",
          email: "toini.malmi@dktaccounting.fi",
        },
        {
          key: "mikael",
          name: "Mikael Knif",
          role: "VAT declarations & Fennoa",
          desc: "Mikael is responsible for VAT declarations and the Fennoa online accounting.",
          phone: "+358 50 374 9614",
          email: "mikael.knif@dktaccounting.fi",
        },
        {
          key: "helena",
          name: "Helena Korkeamäki",
          role: "VAT & tax declarations",
          desc: "Helena is responsible for VAT and tax declarations and other tax matters.",
          email: "helena.korkeamaki@dktaccounting.fi",
        },
        {
          key: "dameh",
          name: "Da Meh Beh",
          role: "VAT & tax declarations",
          desc: "Da Meh handles VAT and tax declarations.",
          email: "dameh.beh@dktaccounting.fi",
        },
      ],
      fennoaTitle: "Fennoa online accounting",
      fennoaDesc: "We are a Fennoa partner. In Fennoa, receipts and documents are handled fully digitally — everything is stored securely online, making your everyday easier. Interested? Contact Mikael.",
      fennoaCta: "Ask Mikael",
    },
    contact: {
      label: "Contact",
      title: "Tell us how we can help.",
      sub: "Leave a message — we'll get back to you as soon as possible.",
      name: "Name",
      email: "Email",
      phone: "Phone (optional)",
      company: "Company (optional)",
      message: "Message",
      submit: "Send message",
      sending: "Sending…",
      success: "Thank you for your message! We'll be in touch soon.",
      error: "Sending failed. Please try again.",
      note: "You can also reach us directly by phone or email.",
      addressLabel: "Visiting address",
      idLabel: "Business ID",
    },
    footer: {
      rights: "All rights reserved.",
      backToTop: "Back to top",
      servicesTitle: "Services",
      companyTitle: "Company",
    },
  },
};
